import { getDocs, limit, query, where } from "firebase/firestore";
import { WordImageUrlPair, WordType } from "../../features/words/types";
import { mapFromDocumentData } from "../../features/words/mapper";
import { WordImage, WordService, WordServiceOptions } from "../WordService";
import { wordsCollection } from "./firestore";

export class FirebaseWordService extends WordService {
  async getWordsWhereFieldEquals(
    field: string,
    value: string,
    options?: WordServiceOptions
  ): Promise<WordType[]> {
    return getDocs(
      query(
        wordsCollection,
        where(field, "==", value),
        limit(Math.max(options?.limit ?? 0, 1))
      )
    ).then((snapshot) => {
      const words: WordType[] = [];
      snapshot.forEach((doc) => {
        if (doc.exists()) {
          words.push(mapFromDocumentData(doc.data()));
        }
      });
      return words;
    });
  }

  async getWordsWhereFieldLike(
    field: string,
    value: string,
    options?: WordServiceOptions
  ): Promise<WordType[]> {
    // there is no like operator in Firestore, so we use a range query
    return getDocs(
      query(
        wordsCollection,
        where(field, ">=", value),
        where(field, "<=", value + "\uf8ff"),
        limit(Math.max(options?.limit ?? 0, 1))
      )
    ).then((snapshot) => {
      const words: WordType[] = [];
      snapshot.forEach((doc) => {
        if (doc.exists()) {
          words.push(mapFromDocumentData(doc.data()));
        }
      });
      return words;
    });
  }

  async getImagesForWords(
    words: string[]
  ): Promise<Record<string, WordImage[]>> {
    // In the firebase model, images are not stored in a separate collection,
    // we can get them directly from the word documents
    throw new Error("Method not implemented.");
  }

  async getImagesForWord(word: string): Promise<WordImage[]> {
    // In the firebase model, images are not stored in a separate collection,
    // we can get them directly from the word documents
    throw new Error("Method not implemented.");
  }

  async getRandomWordImagesPairs(): Promise<WordImageUrlPair[]> {
    return [];
  }
}
